import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Twitter, Linkedin, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#030712]" data-testid="site-footer">
      <div className="mfb-container py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-2.5">
            <div className="relative w-9 h-9 rounded-lg overflow-hidden flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-sky-500 via-sky-600 to-[#0A1128]" />
              <span className="relative font-bold text-white text-sm">M</span>
              <div className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-[#D4AF37] ring-2 ring-[#030712]" />
            </div>
            <div className="font-[Outfit] text-lg font-semibold tracking-tight text-white">My Funding Bank</div>
          </div>
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
            Premium AI-driven wealth management. Invest across mutual funds, bonds, digital gold, forex and travel — all from one institutional-grade account.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[Twitter, Linkedin, Instagram, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-sky-500/40 transition-colors"
                data-testid={`footer-social-${i}`}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-4">Products</div>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/investments" className="hover:text-white">Investments</Link></li>
            <li><Link to="/forex" className="hover:text-white">Forex Trading</Link></li>
            <li><Link to="/gold" className="hover:text-white">Gold</Link></li>
            <li><Link to="/travel" className="hover:text-white">Travel</Link></li>
            <li><Link to="/download" className="hover:text-white">Download App</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-4">Company</div>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/admin/login" className="hover:text-white">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-4">Reach Us</div>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> One Marina Towers, Level 38, Dubai · Mumbai · Singapore</li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#D4AF37]" /> support@myfundingbank.com</li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#D4AF37]" /> +1 (800) 555-MFB-1</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="mfb-container py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} My Funding Bank. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link>
            <span className="text-slate-600">myfundingbank.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
